import React, { useState, useRef } from "react";
import "./header.css"; // For the animations shown further below

function Header({ darkMode, toggleDarkMode }) {
  const [animationActive, setAnimationActive] = useState(false);
  const hoverTimerRef = useRef(null);

  // Trigger the animation if mouse stays over the header for 5 seconds
  const handleMouseEnter = () => {
    hoverTimerRef.current = setTimeout(() => {
      setAnimationActive(true);
    }, 5000); // 5 seconds
  };

  // Reset when the mouse leaves
  const handleMouseLeave = () => {
    clearTimeout(hoverTimerRef.current);
    setAnimationActive(false);
  };

  // (Optional) For a "pushed away by cursor" effect,
  // track mouse position and apply dynamic transform:
  const handleMouseMove = (e) => {
    if (!animationActive) return;

    // We’ll move the text slightly based on pointer position.
    // Adjust these multipliers for a stronger or weaker effect.
    const el = e.currentTarget.querySelector(".header-center p");
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // Distance from element center
    const distX = e.clientX - centerX;
    const distY = e.clientY - centerY;

    // Adjust for how “fluidly” you want it to move
    const moveFactor = 0.05; // smaller => more subtle
    const scaleFactor = 1.2; // how large to scale

    el.style.transform = `translate(${distX * moveFactor}px, ${distY * moveFactor}px) scale(${scaleFactor})`;
  };

  return (
    <header
      className="header"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <div className="header-left">
        <div className="logo-container">
          <h1
            className="siteTitle"
            onClick={() => (window.location.href = "/")}
          >
            iv4.io
          </h1>
          {/* ... your logo, etc. */}
        </div>
      </div>

      <div className="header-center specialHeader">
        {/* Apply an extra class to <p> if animationActive is true */}
        <p className={animationActive ? "animate-color-fade" : ""}>
          A simple and free tool to find your public IP address
        </p>
      </div>

      <div className="header-right">
        <button className="dark-mode-toggle" onClick={toggleDarkMode}>
          {darkMode ? "☀️ Light" : "🌙 Dark"}
        </button>
      </div>
    </header>
  );
}

export default Header;
